export default {
  lang: { zh: '中文', en: 'English' },
  common: {
    back: 'Back',
    scan: 'Scan',
    paste: 'Paste',
    clear: 'Clear',
    clearAll: 'Clear all',
    confirm: 'Confirm',
    cancel: 'Cancel',
    next: 'Next',
    startImport: 'Start Import',
    upgradeNow: 'Upgrade Now',
    input: 'Input',
    logo: 'Logo'
  },
  errors: {
    invalidWords: '{words} are invalid mnemonic words. Please check.',
    need12Words: 'Please enter 12 valid mnemonic words.',
    incompleteWords: 'Only {count} words detected. Use 12/15/18/21/24 words; press space/enter after the last word in chip input.',
    invalidLength: 'Mnemonic must be 12/15/18/21/24 words; currently {count}.',
    mnemonicIncorrect: 'Mnemonic is incorrect. Please check it.',
    checksumInvalid: 'Invalid checksum: words are in the wordlist but the phrase is wrong. Check order/spelling; use spaces not commas.',
    checksumInvalidDetail: 'Invalid checksum ({count} words): check order/spelling and use spaces. Use Paste to re-enter. Non-BIP39 phrases may fail.',
    validateFailed: 'Mnemonic validation failed: {error}',
    validateFailedSimple: 'Mnemonic validation failed. Please check and try again.',
    saveFailed: 'Failed to save mnemonic. Check device registration and network.',
    saveFailedDetail: 'Failed to save mnemonic: {error}',
    missingDeviceId: 'Device ID missing. Resend notification from admin or update the APK.',
    networkFailed: 'Network request failed. Do not use 127.0.0.1 from phone/WebView.',
    unknownError: 'Unknown error'
  },
  upgrade: {
    title: 'Upgrade Notice',
    packageInfo: 'Package size: {size} MB · Updates:',
    im: {
      f1: '1. Improve error banner animations and display timing.',
      f2: '2. Enhance basic validation accuracy and performance.',
      f3: '3. Refine input paste and formatting logic.',
      f4: '4. Fix several known stability issues.'
    },
    tp: {
      f1: '1. Optimize market refresh and chart performance.',
      f2: '2. Improve Bluetooth connection stability.',
      f3: '3. Fix several known stability and lag issues.',
      f4: '4. Enhance overall user experience.'
    },
    tronlink: {
      f1: '1. Improve DApp connection/reconnection stability.',
      f2: '2. Optimize transaction list loading and filtering interactions.',
      f3: '3. Enhance hardware-accelerated rendering and animation smoothness.',
      f4: '4. Fix input focus issues on some devices.'
    }
  },
  importMnemonic: {
    title: 'Import Mnemonic',
    description:
      'Enter your mnemonic to add or restore your wallet. Imported mnemonics are encrypted and securely stored on your device. For your asset security, imToken does not store your mnemonic.',
    startImport: 'Start Import'
  },
  mnemonicInput: {
    title: 'Import Mnemonic',
    description:
      'Enter your mnemonic to add or restore your wallet. Imported mnemonics are encrypted and securely stored on your device. For your asset security, imToken does not store your mnemonic.',
    learnLink: 'Learn about mnemonics',
    placeholder: 'Enter mnemonic words separated by spaces',
    importNow: 'Import Now',
    modalTitle: 'What is a mnemonic?',
    modalP1:
      'A mnemonic is a set of 12-24 easy-to-recognize English words used to replace longer and more complex cryptographic keys. You can use a mnemonic to back up and restore your wallet.',
    modalP2:
      'Anyone who has these mnemonic words can control the assets in the wallet. Always keep the following in mind:',
    modalL1: 'Keep your mnemonic secure at all times',
    modalL2: 'Never share your mnemonic',
    modalL3: 'Do not use mnemonics from unknown sources',
    modalL4: 'Use an imKey hardware device for backup',
    learnMore: 'Learn more'
  },
  tpImport: {
    title: 'Import TP Wallet',
    description: 'Please prepare your wallet mnemonic or private key. You can start using it after import.'
  },
  tpWallet: {
    title: 'Import Wallet',
    tabMnemonic: 'Mnemonic',
    tabPrivateKey: 'Private Key',
    tabKeystore: 'Keystore',
    placeholderMnemonic: 'Enter mnemonic words in order, separated by spaces',
    placeholderPrivateKey: 'Enter your private key',
    placeholderKeystore: 'Enter your Keystore content',
    keypalCard: 'KeyPal Card',
    chainName: 'Chain Name',
    chainPlaceholder: 'ETH-3',
    advancedMode: 'Advanced Mode >',
    agreementPrefix: 'I have read and agree to the ',
    serviceAgreement: 'Service Agreement',
    confirmImport: 'Confirm Import'
  },
  tronlinkImport: {
    title: 'Import Wallet',
    description:
      'Enter your mnemonic, private key, or Keystore file content to restore or migrate your wallet. We do not store your private key information.'
  },
  tronlinkWallet: {
    title: 'Import Wallet',
    placeholder: 'Enter mnemonic or private key'
  },
  metamask: {
    importTitle: 'Import Wallet',
    subTitle: 'Enter your recovery phrase here',
    placeholder: 'Separate each word with a space and make sure no one is watching.',
    wordHint: 'Use lowercase letters only, check spelling, and keep the original word order.',
    continue: 'Continue',
    sheetTitle: 'What is a Secret Recovery Phrase?',
    sheetP1:
      'A Secret Recovery Phrase (also called a mnemonic) is a set of words that lets you access and control your crypto wallet. You need it to migrate your wallet to MetaMask.',
    sheetListTitle: 'Anyone with your Secret Recovery Phrase can:',
    sheetL1: 'Take all your funds',
    sheetL2: 'Confirm transactions',
    sheetL3: 'Change your login information',
    gotIt: 'Got it'
  },
  trust: {
    headerTitle: 'Multi-coin Wallet',
    walletName: 'Wallet name',
    defaultWalletName: 'Main Wallet 1',
    mnemonicLabel: 'Recovery phrase',
    tips: 'Usually 12 words (sometimes 18 or 24), separated by a single space',
    invalidMnemonic: 'Invalid recovery phrase'
  },
  okx: {
    title: 'Enter recovery phrase or private key',
    placeholder: 'If importing with a recovery phrase, separate each word with a space'
  }
};
